<template>
    <select v-on:change="handleTermSelection" v-model="selectedTerm">
        <option value="" disabled>{{ placeholderOptionText }}</option>
        <option v-for="term in taxonomy.terms" :value="term.slug">{{ capitalizeWords(term.name) }}</option>
    </select>
</template>

<script>
export default {
    data:  function () {
        return {
            selectedTerm: null
        }
    },
    props: {
        taxonomy:        {
            type:    Object,
            default: {}
        },
        currentTermSlug: {
            type:    String,
            default: ""
        },
    },
    mounted() {
        // console.log("TaxonomySelector component mounted!");
        // console.log(this.taxonomy);
        // console.log(this.currentTermSlug);

        this.selectedTerm = this.currentTermSlug;
    },
    computed: {
        placeholderOptionText: function () {
            if(this.taxonomy.taxonomy_display_settings[this.taxonomy.taxonomy_key + '_dropdown_placeholder_text']) {
                return this.taxonomy.taxonomy_display_settings[this.taxonomy.taxonomy_key + '_dropdown_placeholder_text'];
            }
            return "Select a " + this.taxonomy.taxonomy_singular_name;
        }
    },
    methods: {
        capitalizeWords(string) {
            return string.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
        },
        handleTermSelection: function () {
            // console.log(this.selectedTerm)
            for (let i = 0; i < this.taxonomy.terms.length; i++) {
                if (this.taxonomy.terms[i].slug === this.selectedTerm) {
                    window.location.href = this.taxonomy.terms[i].url;
                    return;
                }
            }
        },

    }
}
</script>
